<template>
  <div class="account-container">
    <header>
      <span class="title">账户管理</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="使用者姓名/手机号码" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button :disabled="disabled" @click="dialogDelete = true" v-if="funAuth.includes(39)">删  除</el-button>
        <el-button type="primary" @click="addDetail" v-if="funAuth.includes(37)">新 增</el-button>
      </div>
    </header>
    <el-table ref='multipleTable' :data='tableList' tooltip-effect='dark' style='width: 100%;' @selection-change='handleSelectionChange' class="el-table-01" @row-click="rowClick">
      <el-table-column type='selection' width='55' :selectable="selectFun"></el-table-column>
      <el-table-column prop='user_name' label='使用者姓名'></el-table-column>
      <el-table-column prop='phone' label='手机号码'></el-table-column>
      <el-table-column prop='post_name' label='职务'></el-table-column>
      <el-table-column label='状态'>
        <template slot-scope='scope'>{{ scope.row.status === '0' ? '启用' : '禁用' }}</template>
      </el-table-column>
      <el-table-column prop='role_name' label='角色'></el-table-column>
      <el-table-column prop='create_by' label='创建人'></el-table-column>
      <el-table-column label='创建时间'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后不可恢复</div>
      <div class="prompt">你确定要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="deleteUser">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">{{(userDetail.status == 0) ? '禁用':'启用'}}</div>
      <div class="note">{{(userDetail.status == 0) ? '禁用后将不再允许该用户登录系统。':''}}</div>
      <div class="prompt">{{(userDetail.status == 0) ? '你确定要停用该用户吗？':'你确定要启用该用户吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="userStatus">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="dialogPwd" class="add-box">
      <div class="form-item">
        <span class="item-title"><span class="need">*</span>密码</span>
        <div class="item-right">
          <el-input v-model="password1" placeholder="请输入" size="medium" type="password"></el-input>
        </div>
        <div class="err" v-if="err_pwd1"><i class="el-icon-warning"></i>{{err_pwd1}}</div>
      </div>
      <div class="form-item">
        <span class="item-title"><span class="need">*</span>确认密码</span>
        <div class="item-right">
          <el-input v-model="password2" placeholder="请输入" size="medium" type="password"></el-input>
        </div>
        <div class="err" v-if="err_pwd2"><i class="el-icon-warning"></i>{{err_pwd2}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPwd = false">取 消</el-button>
        <el-button type="primary" @click="editPwd">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n2" v-if="dialogUserDetail" @click="dialogUserDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogUserDetail">
        <header>
          <span>{{userDetail.user_name}}</span>
          <i class="iconfont icon-close" @click="dialogUserDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item active"><span>客户资料</span></div>
        </div>
        <div class="head">
          <span>基本信息</span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(38) || funAuth.includes(39) || funAuth.includes(40)">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" v-if="userDetail.status == 1 && funAuth.includes(40) && userDetail.role_id !== 1">启  用</el-dropdown-item>
              <el-dropdown-item command="2" v-if="userDetail.status == 0 && funAuth.includes(40) && userDetail.role_id !== 1">禁  用</el-dropdown-item>
              <el-dropdown-item command="3" v-if="funAuth.includes(38)">修改密码</el-dropdown-item>
              <el-dropdown-item command="4" v-if="funAuth.includes(39) && userDetail.role_id !== 1">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="editDetail" v-if="funAuth.includes(38)">编辑</el-button>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item single">
                  <span class="title">使用者姓名</span>
                  <div class="item-content">{{userDetail.user_name}}</div>
                </div>
                <div class="item single">
                  <span class="title">手机号码</span>
                  <div class="item-content">{{userDetail.phone}}</div>
                </div>
                <div class="item single">
                  <span class="title">职务</span>
                  <div class="item-content">{{userDetail.post_name}}</div>
                </div>
                <div class="item single">
                  <span class="title">状态</span>
                  <div class="item-content">{{ userDetail.status === '0' ? '启用' : '禁用' }}</div>
                </div>
                <div class="item single">
                  <span class="title">角色</span>
                  <div class="item-content">{{userDetail.role_name}}</div>
                </div>
                <div class="item single">
                  <span class="title">备注</span>
                  <div class="item-content">{{userDetail.remark}}</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                系统信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">创建人</span>
                  <div class="item-content">{{userDetail.create_by}}</div>
                </div>
                <div class="item">
                  <span class="title">创建时间</span>
                  <div class="item-content">{{userDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item">
                  <span class="title">修改人</span>
                  <div class="item-content">{{userDetail.modify_by}}</div>
                </div>
                <div class="item">
                  <span class="title">修改时间</span>
                  <div class="item-content">{{userDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-container>
    </transition>

    <div class="mask" v-if="dialogAddDetail" @click="dialogAddDetail = false"></div>
    <transition name="slide">
      <el-container class="add-dialog" v-if="dialogAddDetail">
        <header>账号管理
          <i class="iconfont icon-close" @click="dialogAddDetail = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">账号管理</div>
            <div class="h2">管理中央控制台的所有登录账号</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item single">
                <span class="item-title item-title2"><span><span class="need">*</span>使用者</span><span>姓名</span></span>
                <div class="item-right">
                  <el-input v-model="userName" placeholder="请输入(必填)" size="medium" maxlength="25"></el-input>
                </div>
                <div class="err" v-if="err_un"><i class="el-icon-warning"></i>{{err_un}}</div>
              </div>
              <div class="form-item single50">
                <span class="item-title"><span class="need">*</span>手机号码</span>
                <div class="item-right">
                  <el-input v-model="phone" placeholder="请输入(必填)" size="medium"></el-input>
                </div>
                <div class="err" v-if="err_p"><i class="el-icon-warning"></i>{{err_p}}</div>
              </div>
              <div class="form-item" v-if="!dialogUserDetail">
                <span class="item-title"><span class="need">*</span>密码</span>
                <div class="item-right">
                  <el-input v-model="password1" placeholder="请输入(必填)" size="medium" type="password"></el-input>
                </div>
                <div class="err" v-if="err_pwd1"><i class="el-icon-warning"></i>{{err_pwd1}}</div>
              </div>
              <div class="form-item" v-if="!dialogUserDetail">
                <span class="item-title"><span class="need">*</span>确认密码</span>
                <div class="item-right">
                  <el-input v-model="password2" placeholder="请输入(必填)" size="medium" type="password"></el-input>
                </div>
                <div class="err" v-if="err_pwd2"><i class="el-icon-warning"></i>{{err_pwd2}}</div>
              </div>
              <div class="form-item">
                <span class="item-title">职务</span>
                <div class="item-right">
                  <el-input v-model="post_name" placeholder="请输入" size="medium"></el-input>
                </div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>状态</span>
                <div class="item-right">
                  <el-select v-model="status" placeholder="请选择(必填)" :disabled="dialogUserDetail">
                    <el-option v-for="item in sOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err_s"><i class="el-icon-warning"></i>{{err_s}}</div>
              </div>
              <div class="form-item single50">
                <span class="item-title"><span class="need">*</span>角色</span>
                <div class="item-right">
                  <el-select v-model="role" placeholder="请选择(必填)" disabled="disabled" v-if="userDetail.role_id == 1">
                    <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <el-select v-model="role" placeholder="请选择(必填)" v-if="userDetail.role_id != 1">
                    <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id" v-if="item.id != 1"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err_r"><i class="el-icon-warning"></i>{{err_r}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title">备注</span>
                <div class="item-right">
                  <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAddDetail = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>

  </div>
</template>
<script>
import md5 from 'js-md5'
import {HTTPServer} from '@/common/js/ajax.js'
import tool from '@/common/js/tool.js'
import {regular, TFParameter} from '@/common/js/constant.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>账户管理</b>',
      funAuth: [],
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      disabled: true,
      dialogDelete: false,
      dialogAddDetail: false,
      dialogUserDetail: false,
      userDetail: {},
      dialogStatus: false,
      dialogPwd: false,
      sOptions: [{value: '0', label: '启用'}, {value: '1', label: '禁用'}],
      roleList: [],
      userName: '',
      err_un: '',
      phone: '',
      err_p: '',
      password1: '',
      err_pwd1: '',
      password2: '',
      err_pwd2: '',
      post_name: '',
      status: '0',
      err_s: '',
      role: '',
      err_r: '',
      remark: ''
    }
  },
  mixins: [mixin],
  mounted () {
    this.searchValue = ''
    this.queryFchBtnAuth({moduleId: 11})
    this.queryUserList()
  },
  methods: {
    selectFun (tag, tag1, tag3) {
      console.log(tag, tag1, tag3)
      // if (tag.role_id === 1) {
      //   return false
      // }
      return tag.role_id !== 1
    },
    /** 获取列表 */
    queryUserList (key, id) {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryUserList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
        if (key === 'userDetail') {
          var contains = tool.contains(this.tableList, 'id', id)
          if (contains) {
            this.userDetail = contains
          }
        }
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryUserList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryUserList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryUserList()
    },
    // 行的点击事件
    audit (val) {
      this.$router.push({name: 'ApplyDetail', query: {'id': val.id}, params: {detail: 3}})
    },
    /** 删除 */
    applyDelete () {
      var id = []
      for (var i = 0; i < this.multipleSelection.length; i++) {
        id.push(this.multipleSelection[i].id)
      }
      var jsondata = {'id': id.toString()}
      HTTPServer.deleteApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryUserList()
        this.dialogDelete = false
      })
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_un = ''
      this.err_p = ''
      this.err_pwd1 = ''
      this.err_pwd2 = ''
      this.err_s = ''
      this.err_r = ''
      if (!this.userName) {
        this.err_un = '使用者姓名不能为空'
        return false
      }
      if (!this.phone) {
        this.err_p = '手机号码不能为空'
        return false
      }
      if (!regular.phone.test(this.phone)) {
        this.err_p = '手机号码格式不正确'
        return false
      }
      if (!this.dialogUserDetail) {
        if (!this.password1) {
          this.err_pwd1 = '密码不能为空'
          return false
        }
        if (this.password1.length < 6 || this.password1.length > 13) {
          this.err_pwd1 = '密码格式由6-13位数字、字母、特殊符号组成'
          return false
        }
        if (!this.password2) {
          this.err_pwd2 = '确认密码不能为空'
          return false
        }
        if (this.password1 !== this.password2) {
          this.err_pwd2 = '两次输入的密码不一致'
          return false
        }
      }
      if (!this.status) {
        this.err_s = '状态不能为空'
        return false
      }
      if (!this.role) {
        this.err_r = '角色不能为空'
        return false
      }
      return true
    },
    /** 新增用户 （弹窗） */
    addDetail () {
      HTTPServer.queryRoleList({}, 'Loading').then((res) => {
        this.roleList = res
        if (res.length > 0) {
          this.role = res[0].id
        }
        this.dialogAddDetail = true
        this.userName = ''
        this.phone = ''
        this.password1 = ''
        this.password2 = ''
        this.post_name = ''
        this.status = '0'
        this.role = ''
        this.remark = ''
      })
    },
    /** 新增、编辑用户 */
    dialogSave () {
      var b = this.dataTraversal()
      if (!b) {
        return
      }
      var jsondata = {'account_pwd': md5(md5(this.password1 + TFParameter.TEAMFACEPWD)), 'user_name': this.userName, 'post_name': this.post_name, 'phone': this.phone, 'role_id': this.role, 'status': this.status, 'remark': this.remark}
      if (this.dialogUserDetail) {
        jsondata.id = this.userDetail.id
        delete jsondata.account_pwd
        HTTPServer.editUser(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.dialogAddDetail = false
          this.queryUserList('userDetail', jsondata.id)
        })
      } else {
        HTTPServer.savaUser(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.dialogAddDetail = false
          this.queryUserList()
        })
      }
    },
    /** 进入客户详情 */
    rowClick (row, event, column) {
      this.activeNames = ['1', '2']
      this.userDetail = row
      this.dialogUserDetail = true
    },
    /** 详情 - 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogStatus = true
      } else if (command === '2') {
        this.dialogStatus = true
      } else if (command === '3') {
        this.dialogPwd = true
        this.password1 = ''
        this.err_pwd1 = ''
        this.password2 = ''
        this.err_pwd2 = ''
      } else if (command === '4') {
        this.dialogDelete = true
      }
    },
    /** 编辑用户 （弹窗） */
    editDetail () {
      HTTPServer.queryRoleList({}, 'Loading').then((res) => {
        this.roleList = res
        this.userName = this.userDetail.user_name
        this.phone = this.userDetail.phone
        this.status = this.userDetail.status
        this.post_name = this.userDetail.post_name
        this.remark = this.userDetail.remark
        this.role = this.userDetail.role_id
        this.err_un = ''
        this.err_p = ''
        this.err_s = ''
        this.err_r = ''
        this.dialogAddDetail = true
      })
    },
    /** 禁用/启用用户 */
    userStatus () {
      var jsondata = {id: this.userDetail.id, status: (this.userDetail.status === '0') ? '1' : '0'}
      HTTPServer.enableDisableUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.dialogStatus = false
        this.userDetail.status = jsondata.status
        this.queryUserList()
      })
    },
    /** 删除用户 */
    deleteUser () {
      var arr = []
      var message = ''
      if (this.dialogUserDetail) {
        if (this.userDetail.status === '0') {
          message = '该账号启用中，不能删除'
        }
        arr.push(this.userDetail.id)
      } else {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].status === '0') {
            message = '已选启用中的账号，不能删除'
          }
          arr.push(this.multipleSelection[i].id)
        }
      }
      if (message) {
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
        return
      }
      var jsondata = {'id': arr.toString()}
      HTTPServer.delUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.dialogDelete = false
        if (this.dialogUserDetail) {
          this.dialogUserDetail = false
          this.queryUserList('userDetail', jsondata.id)
        } else {
          this.queryUserList()
        }
      })
    },
    /** 修改用户密码 */
    editPwd () {
      this.err_pwd1 = ''
      this.err_pwd2 = ''
      if (!this.password1) {
        this.err_pwd1 = '密码不能为空'
        return false
      }
      if (this.password1.length < 6 || this.password1.length > 13) {
        this.err_pwd1 = '密码格式由6-13位数字、字母、特殊符号组成'
        return false
      }
      if (!this.password2) {
        this.err_pwd2 = '确认密码不能为空'
        return false
      }
      if (this.password1 !== this.password2) {
        this.err_pwd2 = '两次输入的密码不一致'
        return false
      }
      var jsondata = {accountId: this.userDetail.id, passWord: md5(md5(this.password1 + TFParameter.TEAMFACEPWD))}
      HTTPServer.editPwd(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.dialogPwd = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/platform/account.vue